import React, { useEffect } from "react";
import { Input } from "@windmill/react-ui";

const InputVehcile = ({
  vehicleReg,
  onChange,
  register,
  errors,
  trigger,
  setValue,
}) => {
  useEffect(() => {
    // Set initial values for editing
    vehicleReg.forEach((value, index) => {
      setValue(`vehicleReg[${index}]`, value);
    }); // Trigger validation for all fields
  }, [vehicleReg, setValue]);

  const handleInputChange = (e, index) => {
    const updatedValues = [...vehicleReg];
    const value = e.target.value.toUpperCase();

    // Validation patterns for each input field
    const patterns = [/^[A-Z]*$/, /^[0-9]*$/, /^[A-Z]*$/, /^[0-9]*$/];

    if (patterns[index].test(value)) {
      updatedValues[index] = value;
      onChange(updatedValues);
    }
  };

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex space-x-2">
        {vehicleReg.map((value, index) => {
          const placeholders = ["XX", "99", "XX", "9999"];
          const maxLengths = [2, 2, 2, 4];
          const minLengths = [2, 2, 1, 4];

          return (
            <div key={index} className="flex flex-col space-y-1">
              {/* Input Field */}
              <div className="border rounded">
                <Input
                  {...register(`vehicleReg[${index}]`, {
                    required: true,
                    minLength: {
                      value: minLengths[index],
                      message: `Minimum length is ${minLengths[index]}`,
                    },
                  })} // Register input with validation
                  value={value}
                  onChange={(e) => handleInputChange(e, index)}
                  maxLength={maxLengths[index]}
                  minLength={minLengths[index]}
                  placeholder={placeholders[index]}
                  isInvalid={!!errors?.vehicleReg?.[index]} // Show error if any field is empty
                  className="text-center"
                  autoComplete="off"
                  style={{ height: "40px" }}
                />
              </div>

              {/* Error message placed outside of the input */}
              {errors?.vehicleReg?.[index] && (
                <p className="text-red-500 text-sm mt-1">
                  This field is required
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InputVehcile;
